export default {
  local: {
    GRAPHQL_URL: '//localhost:3000/graphql',
    IMG_URL: '//becollective-dev.imgix.net',
    WEB_URL: '//localhost:4000',
    API_URL: 'https://dev21.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-dev',
    DATA_URL: 'https://clients-dev.becollective.com/data',
  },
  datAu: {
    GRAPHQL_URL: 'https://dat21.becollective.com/graphql',
    IMG_URL: 'https://becollective-dat.imgix.net',
    WEB_URL: 'https://dat21.becollective.com',
    API_URL: 'https://dat21.becollective.com/api',
    DATA_URL: 'https://clients-dat.becollective.com/data',
  },
  testingAu: {
    GRAPHQL_URL: 'https://testing-ju0gee7nahJ7.becollective.com/graphql',
    IMG_URL: 'https://becollective-testing-au.imgix.net',
    WEB_URL: 'https://testing-ju0gee7nahJ7.becollective.com',
    API_URL: 'https://testing-ju0gee7nahJ7.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-dev',
    DATA_URL: 'https://clients-testing-ju0gee7nahJ7.becollective.com/data',
  },
  devAu: {
    GRAPHQL_URL: 'https://dev21.becollective.com/graphql',
    IMG_URL: 'https://becollective-dev-au.imgix.net',
    WEB_URL: 'https://dev21.becollective.com',
    API_URL: 'https://dev21.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-dev',
    DATA_URL: 'https://clients-dev.becollective.com/data',
  },
  stagingAu: {
    GRAPHQL_URL: 'https://staging21.becollective.com/graphql',
    IMG_URL: 'https://becollective-staging-au.imgix.net',
    WEB_URL: 'https://staging21.becollective.com',
    API_URL: 'https://staging21.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-staging',
    DATA_URL: 'https://clients-staging.becollective.com/data',
  },
  demoAu: {
    GRAPHQL_URL: 'https://demo21.becollective.com/graphql',
    IMG_URL: 'https://becollective-demo-au.imgix.net',
    WEB_URL: 'https://demo21.becollective.com',
    API_URL: 'https://demo21.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-demo',
    DATA_URL: 'https://clients-demo.becollective.com/data',
  },
  productionAu: {
    GRAPHQL_URL: 'https://app.becollective.com/graphql',
    IMG_URL: 'https://becollective-production-au.imgix.net',
    WEB_URL: 'https://app.becollective.com',
    API_URL: 'https://app.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-prod-iyjlb',
    DATA_URL: 'https://clients.becollective.com/data',
  },
  productionEu: {
    GRAPHQL_URL: 'https://eu.becollective.com/graphql',
    IMG_URL: 'https://becollective-eu.imgix.net',
    WEB_URL: 'https://eu.becollective.com',
    API_URL: 'https://eu.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-prod-eu',
    DATA_URL: 'https://clients-production-eu.becollective.com/data',
  },
  productionUk: {
    GRAPHQL_URL: 'https://uk.becollective.com/graphql',
    IMG_URL: 'https://becollective-uk.imgix.net',
    WEB_URL: 'https://uk.becollective.com',
    API_URL: 'https://uk.becollective.com/api',
    LOGROCKET_KEY: '5asdvq/be-collective-prod-uk',
    DATA_URL: 'https://clients-production-uk.becollective.com/data',
  },
};
